import React, { useEffect, useState } from "react";
import { Switch } from "antd";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

import Edit from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Pagination from '@material-ui/lab/Pagination';
import CustomInput from "components/CustomInput/CustomInput.js";
import Search from "@material-ui/icons/Search";

import Button from "components/CustomButtons/Button.js";
import Table from "components/Table/Table.js";

import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import CardFooter from "components/Card/CardFooter.js";
import 'bootstrap/dist/css/bootstrap.min.css';
import api from "assets/services/api.js";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import styles3 from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";

import ModalUpdateRegion from "components/ModalUpdateRegion/ModalUpdateRegion";
import ModalAddRegion from "components/ModalAddRegion/ModalAddRegion";
import ModalAddZone from "components/ModalAddZone/ModalAddZone";

import useAuth from "hooks/useAuth";
import ModalUpdateZone from "components/ModalUpdateZone/ModalUpdateZone";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#000",
        opacity: .8
    },
    floatRight: {
        float: "right"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    acctAll: {
        float: "right",
        marginTop: "-29px"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    },
    colorRed: {
        color: 'red'
    },
    colorOrange: {
        color: '#ff9500'
    },
    colorBlack: {
        color: '#0000'
    },
    toogleclass: {
        marginTop: "20px",
        marginBottom: "15px",
        width: "8em",
    },
    selectText: {
        margin: "20px",

    }
};
const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);
const useStyles3 = makeStyles(styles3);

export default function Region() {
    const classes = useStyles();
    const classes2 = useStyles2();
    const classes3 = useStyles3();
    const header = {
        zone: ["Codigo", "Nome", "Ações"],
        region: ["Codigo", "Nome", "Vendedor", "Ações"]
    }
    const { storageId, storageUserType } = useAuth();
    const [regions, setRegions] = useState([]);
    const [zones, setZones] = useState([]);
    const [toogle, setToogle] = useState(false);

    const [search, setSearch] = useState("")
    const [totalPages, setTotalPages] = useState();
    const [page, setPage] = useState(1);

    const [modal, setModal] = useState(false);
    const [modalShowAdd, setModalShowAdd] = useState(false);
    const [modalShowAddZone, setModalShowAddZone] = useState(false);
    const [modalShowUpdate, setModalShowUpdate] = useState(false);
    const [modalShowUpdateZone, setModalShowUpdateZone] = useState(false);
    const [modalShowDelete, setModalShowDelete] = useState(false);
    const [index, setIndex] = useState({ id: 1 });

    useEffect(() => {
        getRegions();
    }, []);
    useEffect(() => {
        if (toogle) {
            getZones();
        } else {
            getRegions();
        };
    }, [toogle]);
    useEffect(() => {
        if (toogle) {
            getZones();
        } else {
            getRegions();
        };
    }, [totalPages, page, search]);
    const loadModal = async () => {
        setModal(true);
    };
    function callModalAdd() {
        if (!modalShowAdd) {
            loadModal();
        };
        if (toogle) {
            setModalShowAddZone(true);
        } else {
            setModalShowAdd(true);
        };
    };
    function callModal(index) {
        if (!modalShowUpdate) {
            loadModal();
        }
        setIndex(index);
        if (toogle) {
            setModalShowUpdateZone(true);
        } else {
            setModalShowUpdate(true);
        };
    };
    function callModalDelete(index) {
        if (!modalShowDelete) {
            loadModal();
        }
        setIndex(index);
        setModalShowDelete(true);
    };
    const handleChange = (event, value) => {
        setPage(value);
    };
    const toogler = () => {
        setToogle(!toogle);
    }
    async function getRegions() {
        try {
            const response = await api.get(`/region/${storageId}?type=${storageUserType}&perPage=10&page=${page}&search=${search}`);
            if (response.status === 200) {
                setRegions(response.data.regions || []);
                setTotalPages(response.data.totalPages || 1);
            };
        } catch (error) {

        };
    };
    async function getZones() {
        try {
            const response = await api.get(`/zone/${storageId}?type=${storageUserType}&perPage=10&page=${page}&search=${search}`);
            if (response.status === 200) {
                setZones(response.data.zones || []);
                setTotalPages(response.data.totalPages || 1);
            };
        } catch (error) {

        };
    };
    function getRegionsForTable() {
        let table_region = [];
        for (let i = 0; i < regions.length; i++) {
            table_region[i] = [];
            table_region[i].push(regions[i].code);
            table_region[i].push(regions[i].name);
            table_region[i].push(regions[i].sellsman_name);
            table_region[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip id="tooltip-top" title="Editar" placement="top" classes={{ tooltip: classes2.tooltip }}>
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callModal(regions[i])}>
                            <Edit className={classes2.tableActionButtonIcon + " " + classes2.edit} />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        };
        return table_region;
    };
    function getZonesForTable() {
        let table_zone = [];
        for (let i = 0; i < zones.length; i++) {
            table_zone[i] = [];
            table_zone[i].push(zones[i].code);
            table_zone[i].push(zones[i].name);
            table_zone[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip
                        id="tooltip-top"
                        title="Editar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Edit"
                            className={classes2.tableActionButton}
                            onClick={() => callModal(zones[i])}

                        >
                            <Edit
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.edit
                                }
                            />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        };
        return table_zone;
    };

    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
                            <CardIcon color={toogle ? "info" : "success"}>
                                <Icon>content_copy</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <div className="d-flex justify-content-center">
                        <p className={classes.selectText}>região</p>
                        <Switch className={classes.toogleclass} onClick={() => toogler()} />
                        <p className={classes.selectText}>zona</p>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <h6 className={classes.colorCard}>Clique abaixo para adicionar uma {toogle ? 'zona' : 'região'}</h6>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <Button color={toogle ? "info" : "success"} className={classes.margintp + classes.maxwidht} onClick={() => callModalAdd()}>
                            Adicionar {toogle ? 'zona' : 'região'}
                        </Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
                <div className={classes3.searchWrapper}>
                    <CustomInput
                        formControlProps={{
                            className: classes3.margin + " " + classes3.search
                        }}
                        inputProps={{
                            placeholder: "Busca por cnpj, razão social ou nome fantasia",
                            inputProps: {
                                "aria-label": "Search",
                                type: "text",
                                value: search,
                                onChange: event => setSearch(event.target.value)
                            }
                        }}
                    />
                    <Button color="white" aria-label="edit" justIcon round>
                        <Search />
                    </Button>
                </div>
            </GridItem>
            <Card>
                <CardHeader className={classes.zindex} color={toogle ? "info" : "success"}>
                    <h4 className={classes.cardTitleWhite}>{toogle ? "Zona" : "Região"}</h4>
                </CardHeader>
                <CardBody>
                    <Table
                        index={index}
                        tableHeaderColor="primary"
                        tableHead={toogle ? header.zone : header.region}
                        tableData={toogle ? getZonesForTable() : getRegionsForTable()}
                    />
                </CardBody>
            </Card>
            {modalShowUpdate && modal && (
                <ModalUpdateRegion key={String("Upd_" + index.id)} props={index} show={modalShowUpdate} onHide={() => setModalShowUpdate(false)} getRegions={getRegions} />
            )}
            {modalShowUpdateZone && modal && (
                <ModalUpdateZone key={String("Upd_" + index.id)} props={index} show={modalShowUpdateZone} onHide={() => setModalShowUpdateZone(false)} getZones={getZones} />
            )}
            {modalShowAdd && modal && (
                <ModalAddRegion key={String("Cli_" + index.id)} props={index} show={modalShowAdd} onHide={() => setModalShowAdd(false)} getRegions={getRegions} />
            )}
            {modalShowAddZone && modal && (
                <ModalAddZone key={String("Cli_" + index.id)} props={index} show={modalShowAddZone} onHide={() => setModalShowAddZone(false)} getZones={getZones} />
            )}
            <Pagination count={totalPages} page={page} onChange={handleChange} />
        </GridContainer>
    );

}
